import {
  PositionCategoryKind,
  PositionRangeKind,
  PositionTextKind,
  UserCategoryKind,
  UserExprTextKind,
  UserRangeKind,
} from '@revelio/data-access';

// Type alias for TalentDiscoveryV3Tags - union of all possible tag types
export type TalentDiscoveryV3Tags =
  | PositionCategoryKind
  | UserCategoryKind
  | PositionRangeKind
  | UserRangeKind
  | PositionTextKind
  | UserExprTextKind;

// Const object that provides enum-like access to all tag values
export const TalentDiscoveryV3Tags = {
  // Position category kinds
  City: PositionCategoryKind.City,
  CompanyId: PositionCategoryKind.CompanyId,
  Contingent: PositionCategoryKind.Contingent,
  Country: PositionCategoryKind.Country,
  EmploymentRelationship: PositionCategoryKind.EmploymentRelationship,
  FlightRisk: PositionCategoryKind.FlightRisk,
  Msa: PositionCategoryKind.Msa,
  Prestige: PositionCategoryKind.Prestige,
  Region: PositionCategoryKind.Region,
  RemoteSuitability: PositionCategoryKind.RemoteSuitability,
  RicsK10: PositionCategoryKind.RicsK10,
  RicsK50: PositionCategoryKind.RicsK50,
  RicsK400: PositionCategoryKind.RicsK400,
  RoleK7: PositionCategoryKind.RoleK7,
  RoleK150: PositionCategoryKind.RoleK150,
  RoleK1500: PositionCategoryKind.RoleK1500,
  RoleK15000: PositionCategoryKind.RoleK15000,
  RoleK17000: PositionCategoryKind.RoleK17000,
  Rsid: PositionCategoryKind.Rsid,
  Seniority: PositionCategoryKind.Seniority,
  WorkSchedule: PositionCategoryKind.WorkSchedule,
  // User category kinds
  Ethnicity: UserCategoryKind.Ethnicity,
  Gender: UserCategoryKind.Gender,
  HighestDegree: UserCategoryKind.HighestDegree,
  SkillLvl_1: UserCategoryKind.SkillLvl_1,
  SkillLvl_2: UserCategoryKind.SkillLvl_2,
  SkillLvl_3: UserCategoryKind.SkillLvl_3,
  SkillLvl_4: UserCategoryKind.SkillLvl_4,
  SkillLvl_5: UserCategoryKind.SkillLvl_5,
  UserCity: UserCategoryKind.UserCity,
  UserCountry: UserCategoryKind.UserCountry,
  UserMsa: UserCategoryKind.UserMsa,
  UserRegion: UserCategoryKind.UserRegion,
  UserState: UserCategoryKind.UserState,
  // Position range kinds
  SalaryBase: PositionRangeKind.SalaryBase,
  SalaryTotal: PositionRangeKind.SalaryTotal,
  // User range kinds
  GraduationYear: UserRangeKind.GraduationYear,
  YearsOfExp: UserRangeKind.YearsOfExp,
  // Position text kinds
  Title: PositionTextKind.Title,
  // User text kinds
  Desc: UserExprTextKind.Desc,
  Name: UserExprTextKind.Name,
} as const;
